import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UserProfileLayout from "markup/Layout/UserProfileLayout";
import Profilesidebar from "markup/Element/Profilesidebar";
import AdvertCard from "modules/Main/parts/AdvertCard";
import Skeleton from "@material-ui/lab/Skeleton";
import { getFavorites } from "../_redux/favoriteEndpoint";

function MyFavorites(props) {
  const [loading, setLoading] = useState(true);
  const [adverts, setAdverts] = useState([]);

  useEffect(() => {
    getFavorites(1, 48)
      .then((res) => res.data)
      .then((data) => {
        setAdverts(data.results || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <UserProfileLayout>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white p-t50 p-b20">
            <div className="container">
              <div className="row">
                <Profilesidebar {...props} />

                <div className="col-xl-9 col-lg-8 m-b30">
                  <div className="job-bx save-job browse-job clearfix">
                    <div className="job-bx-title clearfix">
                      <h5 className="font-weight-700 pull-left text-uppercase">
                        Favorilerim
                      </h5>
                      <Link
                        to={"/"}
                        className="site-button right-arrow button-sm float-right"
                      >
                        Anasayfa
                      </Link>
                    </div>

                    {loading ? (
                      <div className="row">
                        {[0, 1, 2, 3].map((i) => (
                          <div className="col-sm-6 col-md-4 col-lg-3" key={i}>
                            <Skeleton
                              animation="wave"
                              variant="rect"
                              height={320}
                              className="mb-4"
                            />
                          </div>
                        ))}
                      </div>
                    ) : adverts.length ? (
                      <div className="row">
                        {adverts.map((advert) => (
                          <AdvertCard advert={advert} key={advert.id} />
                        ))}
                      </div>
                    ) : (
                      <div className="text-center p-t30 p-b30">
                        <i
                          className="fa fa-heart-o"
                          style={{ fontSize: 48, color: "#d0d0d0" }}
                        />
                        <p className="m-t20 text-muted">
                          Henüz favori ilanınız bulunmuyor. Beğendiğiniz
                          ilanların kalp ikonuna tıklayarak favorilerinize
                          ekleyebilirsiniz.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserProfileLayout>
  );
}

export default MyFavorites;
